import {
  Dialog, DialogTitle, DialogContent, IconButton,
  Grid, Paper, Typography, Box, Button, TextField,
  Alert, InputAdornment
} from "@mui/material";
import CloseIcon         from "@mui/icons-material/Close";
import PaymentIcon       from "@mui/icons-material/Payment";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const Label = ({ children, color = "#555" }) => (
  <Typography variant="caption" sx={{ color, fontWeight: 600, letterSpacing: 0.5, textTransform: "uppercase", fontSize: "0.65rem" }}>
    {children}
  </Typography>
);

const Val = ({ children, color }) => (
  <Typography variant="body2" sx={{ fontWeight: 700, color: color || "#111", mt: 0.1 }}>
    {children || "—"}
  </Typography>
);

const DuePaymentModal = ({
  open,
  onClose,
  dueSale,
  dueForm,
  setDueForm,
  dueError,
  dueSuccess,
  dueSubmitting,
  onSubmit
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => !dueSubmitting && onClose()}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle sx={{
        fontWeight: 800, bgcolor: "#e65100", color: "#fff",
        display: "flex", alignItems: "center", justifyContent: "space-between"
      }}>
        <Box display="flex" alignItems="center" gap={1}>
          <PaymentIcon />
          Add Installment
        </Box>
        <IconButton onClick={onClose} disabled={dueSubmitting} sx={{ color: "#fff" }} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2.5, pb: 3 }}>

        {/* Summary bar */}
        <Paper elevation={0} sx={{ p: 1.5, mb: 2.5, borderRadius: 2, bgcolor: "#fff8f5", border: "1px solid #ffb74d" }}>
          <Typography variant="body2" fontWeight={700} color="#e65100" mb={0.5}>
            {dueSale?.customerName} — {dueSale?.invoiceNo}
          </Typography>
          <Box display="flex" gap={3}>
            <Box>
              <Label>Total Due</Label>
              <Val>₹{(dueSale?.due?.totalAmount || 0).toLocaleString("en-IN")}</Val>
            </Box>
            <Box>
              <Label>Paid So Far</Label>
              <Val color="#2e7d32">₹{(dueSale?.due?.paidAmount || 0).toLocaleString("en-IN")}</Val>
            </Box>
            <Box>
              <Label>Remaining</Label>
              <Val color="#e65100">₹{(dueSale?.due?.remainingAmount || 0).toLocaleString("en-IN")}</Val>
            </Box>
          </Box>
        </Paper>

        <Grid container spacing={2}>

          {/* Amount */}
          <Grid item xs={12}>
            <TextField
              fullWidth size="small" label="Payment Amount *" type="number"
              value={dueForm.amount}
              onChange={(e) => setDueForm((p) => ({ ...p, amount: e.target.value }))}
              InputProps={{
                startAdornment: <InputAdornment position="start"><CurrencyRupeeIcon sx={{ fontSize: 14 }} /></InputAdornment>
              }}
              helperText={`Max: ₹${(dueSale?.due?.remainingAmount || 0).toLocaleString("en-IN")}`}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
            />
          </Grid>

          {/* Date */}
          <Grid item xs={12}>
            <TextField
              fullWidth size="small" label="Payment Date *" type="date"
              value={dueForm.date}
              onChange={(e) => setDueForm((p) => ({ ...p, date: e.target.value }))}
              InputLabelProps={{ shrink: true }}
              InputProps={{
                startAdornment: <InputAdornment position="start"><CalendarMonthIcon sx={{ fontSize: 14 }} /></InputAdornment>
              }}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
            />
          </Grid>

          {/* Note */}
          <Grid item xs={12}>
            <TextField
              fullWidth size="small" label="Note (optional)" multiline rows={2}
              value={dueForm.note}
              onChange={(e) => setDueForm((p) => ({ ...p, note: e.target.value }))}
              placeholder="e.g. Cash payment — 2nd installment"
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
            />
          </Grid>

        </Grid>

        {/* Error / Success */}
        {dueError   && <Alert severity="error"   sx={{ mt: 1.5, borderRadius: 2 }}>{dueError}</Alert>}
        {dueSuccess && <Alert severity="success" sx={{ mt: 1.5, borderRadius: 2 }}>{dueSuccess}</Alert>}

        {/* Submit */}
        <Button
          fullWidth variant="contained" onClick={onSubmit}
          disabled={dueSubmitting}
          sx={{
            mt: 2.5, py: 1.2, borderRadius: 2, fontWeight: 800, fontSize: "0.9rem",
            bgcolor: dueSubmitting ? "#bdbdbd" : "#e65100",
            "&:hover": { bgcolor: "#bf360c" }
          }}
        >
          {dueSubmitting ? "Processing..." : "✅ Confirm Payment"}
        </Button>

      </DialogContent>
    </Dialog>
  );
};

export default DuePaymentModal;